var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagLt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 140 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26626_60053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.13 30.8101H0.5V61.6201H139.13V30.8101Z",
    fill: "#63AB30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.13 0H0.5V30.81H139.13V0Z",
    fill: "#EAB226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.13 61.6101H0.5V92.4201H139.13V61.6101Z",
    fill: "#D11B1A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26626_60053"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138.63,
    height: 92.42,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagLt);
export default __webpack_public_path__ + "static/media/Flag_LT.2ecf42d40d6b9e44a2229f98a07a7ea0.svg";
export { ForwardRef as ReactComponent };